/* eslint-disable */
import React from 'react';
import ReactMarkdown from 'markdown-to-jsx';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { logger } from '../../utils/logger';

// styled(), not withStyles(). withStyles is the MUI v4 API and throws
// MUI error #15 ("styles argument invalid -- function without a theme in
// context") when no legacy ThemeProvider is above it. Because every blog
// post renders through this file, that exception unmounted the whole React
// tree: #root went 889 chars -> 0 and the page went blank, for real
// visitors as well as the prerenderer. styled() falls back to the default
// theme and needs no provider.
const ListItem = styled('li')(({theme}) => ({
  marginTop: theme.spacing(1),
}));

const options = {
  overrides: {
    div: {
      component: Typography,
    },
    h1: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: 'h5',
      },
    },
    h2: {component: Typography, props: {gutterBottom: true, variant: 'h6'}},
    h3: {
      component: Typography,
      props: {gutterBottom: true, variant: 'subtitle1'},
    },
    h4: {
      component: Typography,
      props: {gutterBottom: true, variant: 'caption', paragraph: true},
    },
    p: {component: Typography, props: {paragraph: true}},
    a: {component: Link},
    li: {
      component: (props) => (
        <ListItem>
          <Typography component="span" {...props} />
        </ListItem>
      ),
    },
  },
};

export default function Markdown(props) {
  return (
    <>
      <ReactMarkdown options={options} {...props} />
      {/* <pre>Markdown :: {JSON.stringify(props, null, 2)}</pre> */}
    </>
    // logger.log("props -> " + props);
    // render(<Markdown># Hello world!</Markdown>, document.body);
  );
}
